import { render, staticRenderFns } from "./DbpyPD_Vendor.vue?vue&type=template&id=5ded609f"
import script from "./DbpyPD_Vendor.vue?vue&type=script&lang=js"
export * from "./DbpyPD_Vendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports